module.exports = "https://product-cdn.staging.surfline.com/kbyg/_next/static/images/all-stories-tile-tablet-7915666b797fd96790e5c50098e0e8ff.png";